<template>
    <v-dialog v-model="dialog" persistent max-width="700px" scrollable>
      <v-card>
        <v-toolbar dark>
        <v-toolbar-title class="headline">Filter customer</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('dialog', false)">close</v-icon>
        </v-toolbar>
          <div style="padding:16px">
            <v-card color="secondary">
            <v-card-text style="padding-top:0;">
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field label="First name" hide-details></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Last name" hide-details></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Tel." hide-details></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Email" hide-details></v-text-field>
              </v-flex>
            </v-layout>
            </v-card-text>
            <v-card-actions class="pt-0">
              <v-spacer/>
              <v-btn color="red" flat @click="$emit('dialog', false)">reset</v-btn>
              <v-btn color="primary" class="black--text" @click="$emit('dialog', false)">
                <v-icon>search</v-icon>
                search  
              </v-btn>
              <v-spacer/>
            </v-card-actions>
            <v-divider/>
            </v-card>
          </div>
          <strong class="pl-3">Result found : 6 customer</strong>
          <v-card-text style="height: auto;padding-top:0;">
          <v-data-table
            :headers="headers"
            :items="customer"
            class="elevation-1"
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.item.num }}</td>
              <td class="text-xs-left">{{ props.item.fname }}</td>
              <td class="text-xs-left">{{ props.item.lname }}</td>
              <td class="text-xs-center">{{ props.item.tel }}</td>
              <td class="text-xs-center">{{ props.item.email }}</td>
              <td class="text-xs-center"><v-btn depressed color="green">select</v-btn></td>
            </template>
          </v-data-table>
          </v-card-text>
      </v-card>
    </v-dialog>
</template>
<script>
  export default {
props:['dialog'],
data () {
  return {
    headers: [
          { text: '#',align: 'center', value: 'num', sortable: false, },
          { text: 'Firstfname',align: 'center',sortable: false,value: 'fname'},
          { text: 'Lastfname',align: 'center', value: 'lname',sortable: false, },
          { text: 'Tel.',align: 'center', value: 'tel', sortable: false, },
          { text: 'Email',align: 'center', value: 'email', sortable: false, },
          { text: 'Select',align: 'center', value: 'select', sortable: false, }
        ],
        customer: [
          {
            fname: 'Frozen',
            lname: 'Yogurt',
            tel: '0894673321',
            email: 'eee@g.co',
            num: '1'
          },
          {
            fname: 'Ice',
            lname: 'cream',
            tel: '0894673321',
            email: 'eee@g.co',
            num: '2'
          },
          {
            fname: 'Eclair',
            lname: 'sandwich',
            tel: '0894673321',
            email: 'ddeee@gdddd.com',
            num: '3'
          },
          {
            fname: 'Frozen',
            lname: 'Yogurt',
            tel: '0894673321',
            email: 'eee@g.co',
            num: '4'
          },
          {
            fname: 'Ice',
            lname: 'cream',
            tel: '0894673321',
            email: 'eee@g.co',
            num: '5'
          },
          {
            fname: 'Eclair',
            lname: 'sandwich',
            tel: '0894673321',
            email: 'ddeee@gdddd.com',
            num: '6'
          }
        ]
  }
}
  }
</script>